module.exports = __webpack_public_path__ + "static/cta-three-bg-1-2-39408669af63397e11fa9058c798593f.png";